// ProtectedRoute.tsx 
import React from "react";
import { 
    Route,
    RouteProps,
    Redirect } from "react-router-dom";
import  useAuth  from "components/Authprovider/Auth";

// We are taking in the component that should be rendered if the user is authed
// We are also passing the rest of the props to the <Route /> component such as
// exact & the pathComponent,
function ProtectedRoute({ ...props }: RouteProps) {
    const { user } = useAuth();
  
    if (!user) return <Redirect to="/login" />;
  
    return <Route {...props} />;
}
  

export default ProtectedRoute;